var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.subscription.start.title"),
          "icon-class": "mdi mdi-home"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 grid-margin stretch-card" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("v-stepper", {
                  ref: "stepper",
                  attrs: { steps: _vm.steps },
                  model: {
                    value: _vm.step,
                    callback: function($$v) {
                      _vm.step = $$v
                    },
                    expression: "step"
                  }
                }),
                _vm._v(" "),
                !_vm.step
                  ? _c("i", {
                      staticClass:
                        "mdi mdi-spin mdi-autorenew mdi-48px text-primary"
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "component-fade", mode: "out-in" } },
                  [
                    !_vm.step ? _c("static-loading-indicator-icon") : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 1
                      ? _c("subscription-start-address", {
                          on: {
                            "step-completed": function($event) {
                              return _vm.$refs.stepper.next()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 2
                      ? _c("subscription-start-questions", {
                          on: {
                            "step-completed": function($event) {
                              return _vm.$refs.stepper.next()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 3 ? _c("subscription-start-billing") : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }